import CustomText from "@components/CustomText";
import color from "@constants/color";
import React from "react";
import Close from "@assets/svg/CloseIcon";
import {
  Modal,
  Image,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
  StyleSheet,
  FlatList,
  useWindowDimensions,
} from "react-native";
import Toast from "react-native-toast-message";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ToastMessage, { ToastConfig } from "@components/Toast";

import { returnRequestCancelV2 } from "../../services/api";

const IMAGE_HEIGHT = 112;
const IMAGE_WIDTH = 112;

const SeeReturnModal = (props) => {
  const { visible, setVisible, data = [], setRefetch } = props;

  const insets = useSafeAreaInsets();
  const { height } = useWindowDimensions();

  const cancelReturnRequest = async (return_req_id) => {
    try {
      await returnRequestCancelV2({
        return_req_id,
        type: "rvp",
      });
      setRefetch((r) => !r);
    } catch (e) {
      ToastMessage("info", e.response.data.message);
      console.log(e);
    }
  };

  const keyExtractor = (item, index) => `${item?.return_req_id}${index}`;

  const Header = () => (
    <View style={styles.headerContainer}>
      <View style={styles.headerImageCont}>
        <Image
          source={{
            uri: "https://public-cdn.citymall.live/cm-admin-storage-public/cl_app_icon%2F1681803681489-delivery-box-icon.png",
          }}
          style={styles.headerImage}
          resizeMode="cover"
        />
        <TouchableNativeFeedback
          testID="cancel"
          onPress={() => {
            setVisible(false);
          }}
        >
          <View style={styles.cross}>
            <Close fill="rgba(0, 0, 0, 0.86)" width="16" height="16" />
          </View>
        </TouchableNativeFeedback>
      </View>
      <CustomText variant="title_16" style={styles.header}>
        रिटर्न आइटम की जानकारी
      </CustomText>
    </View>
  );

  const renderItem = ({ item }) => {
    return (
      <View>
        <View style={{ paddingHorizontal: 16, paddingTop: 30 }}>
          {item?.items &&
            Array.isArray(item.items) &&
            item.items.map((i) => (
              <ItemCard
                key={`${i.return_req_id}-${i.order_item_id}`}
                item={i}
              />
            ))}
          <View style={{ paddingBottom: 16 }}>
            {item?.can_cancel_request ? (
              <TouchableNativeFeedback
                testID="marking"
                onPress={() => cancelReturnRequest(item?.return_req_id)}
              >
                <View style={styles.cancelReturn}>
                  <CustomText variant="title_16" style={{ color: color.white }}>
                    {"कैंसिल रिटर्न "}
                  </CustomText>
                </View>
              </TouchableNativeFeedback>
            ) : null}
          </View>
        </View>
        <View style={styles.saparator} />
      </View>
    );
  };

  const ItemCard = ({ item }) => (
    <View style={styles.mainContainer}>
      <View style={styles.imageContainer}>
        <View style={styles.imageView}>
          <Image
            style={styles.image}
            source={{
              uri: item?.product_image,
            }}
          />
        </View>
      </View>
      <View style={styles.textContainer}>
        <CustomText variant="subtitle_16" style={styles.nameText}>
          {item?.short_name}
        </CustomText>
        <CustomText variant="body_text_3" style={styles.quantityText}>
          {`क्वांटिटी : ${item?.quantity}`}
        </CustomText>
        {item?.label && (
          <View style={{ flexDirection: "row" }}>
            <View style={styles.label}>
              <CustomText
                variant="body_text_4"
                style={{ color: "rgba(255, 46, 0, 1)" }}
              >
                {item?.label}
              </CustomText>
            </View>
          </View>
        )}
      </View>
    </View>
  );

  return (
    <>
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        animationType="slide"
        transparent={true}
        visible={visible}
      >
        <View style={{ flex: 1 }}>
          <TouchableOpacity
            testID="close_modal"
            style={styles.modal}
            activeOpacity={1}
            onPressOut={() => setVisible(false)}
          />
          <View
            style={[
              styles.modalContainer,
              {
                maxHeight: (3 * height) / 4,
                paddingBottom: insets.bottom,
              },
            ]}
          >
            <Header />
            <FlatList
              data={data}
              keyExtractor={keyExtractor}
              renderItem={renderItem}
              style={styles.listContainer}
            />
          </View>
        </View>
        <Toast config={ToastConfig} />
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: "row",
    borderRadius: 16,
    marginBottom: 16,
  },
  imageContainer: {
    width: IMAGE_WIDTH,
  },
  imageView: {
    height: IMAGE_HEIGHT,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.20)",
    overflow: "hidden",
    padding: 8,
  },
  image: {
    height: IMAGE_HEIGHT - 16,
    width: IMAGE_WIDTH - 16,
  },
  textContainer: {
    marginTop: 4,
    marginLeft: 25,
    flex: 1,
  },
  nameText: {
    color: "rgba(0, 0, 0, 0.86)",
  },
  quantityText: {
    color: "rgba(0, 0, 0, 0.56)",
    marginTop: 8,
  },
  headerContainer: {
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  headerImageCont: { flexDirection: "row", justifyContent: "space-between" },
  headerImage: { height: 48, width: 52 },
  cross: {
    height: 24,
    width: 24,
    borderRadius: 12,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    padding: 4,
  },
  header: { color: "rgba(255, 46, 0, 1)", marginTop: 8 },
  label: {
    marginTop: 8,
    backgroundColor: "rgba(255, 46, 0, 0.10)",
    borderRadius: 24,
    paddingHorizontal: 12,
    paddingVertical: 4,
  },
  cancelReturn: {
    backgroundColor: "rgba(255, 46, 0, 1)",
    borderRadius: 8,
    alignItems: "center",
    marginTop: 8,
    paddingVertical: 9,
  },
  saparator: {
    borderBottomColor: "rgba(0, 0, 0, 0.40)",
    borderBottomWidth: 1,
  },
  modalContainer: {
    backgroundColor: color.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
  modal: {
    backgroundColor: "rgba(0,0,0,0.5)",
    flex: 1,
  },
});

export default SeeReturnModal;
